module.exports = __webpack_public_path__ + "static/media/LigneBlue.c15a2012.svg";